import { FreshwatchRolesGuard } from '../../../customized/fresh-watch/components/auth/RolesGuard/FreshwatchRolesGuard';
import { ToggleComponent } from '../../../featureToggle';
import RolesGuard from './RolesGuard';

export default ToggleComponent(RolesGuard, {
  styledComponentsVariants: {
    'fresh-watch': FreshwatchRolesGuard,
  },
});
